import bgUrl from './img/background_no_subject.jpg';
import fgUrl from './img/foreground_subject.png';

const scene = document.getElementById('scene');
const bg = document.getElementById('background');
const fg = document.getElementById('foreground');

bg.style.backgroundImage = `url(${bgUrl})`;
fg.style.backgroundImage = `url(${fgUrl})`;

let targetX = 0, targetY = 0;
let currentX = 0, currentY = 0;
const maxRotationBG = 15;
const maxTranslateBG = 28; // BG bouge beaucoup
const maxTranslateFG = 4;  // FG bouge très peu
const maxRotationFG = 3;
const momentumDecay = 0.88;
let velocityX = 0, velocityY = 0;

function lerp(start, end, amt) {
  return start + (end - start) * amt;
}

function applyTransforms() {
  velocityX *= momentumDecay;
  velocityY *= momentumDecay;

  currentX += velocityX + (targetX - currentX)*0.15;
  currentY += velocityY + (targetY - currentY)*0.15;

  const rotXBG = -currentY * maxRotationBG;
  const rotYBG = currentX * maxRotationBG;

  const translateXBG = currentX * maxTranslateBG;
  const translateYBG = currentY * maxTranslateBG;

  // BG zoomé plus large pour marges
  bg.style.transform =
    `translateZ(-40px) scale(1.3) translateX(${translateXBG}px) translateY(${translateYBG}px) rotateX(${rotXBG * 0.5}deg) rotateY(${rotYBG * 0.5}deg)`;

  // Sujet très discret
  const rotXFG = -currentY * maxRotationFG;
  const rotYFG = currentX * maxRotationFG;

  const translateXFG = currentX * maxTranslateFG;
  const translateYFG = currentY * maxTranslateFG;

  fg.style.transform =
    `translateZ(40px) scale(1) translateX(${translateXFG}px) translateY(${translateYFG}px) rotateX(${rotXFG}deg) rotateY(${rotYFG}deg) rotateZ(${currentX * 2}deg)`;

  requestAnimationFrame(applyTransforms);
}

function updateFromMouse(e) {
  const rect = scene.getBoundingClientRect();
  const x = (e.clientX - rect.left) / rect.width;
  const y = (e.clientY - rect.top) / rect.height;

  const newX = (x-0.5)*2;
  const newY = (y-0.5)*2;

  velocityX = newX - targetX;
  velocityY = newY - targetY;

  targetX = newX;
  targetY = newY;
}

function updateFromOrientation(e) {
  if(e.beta===null || e.gamma===null) return;

  const tiltX = Math.min(Math.max(e.beta,-30),30);
  const tiltY = Math.min(Math.max(e.gamma,-30),30);

  const newX = tiltY/30;
  const newY = -tiltX/30;

  velocityX = newX - targetX;
  velocityY = newY - targetY;

  targetX = newX;
  targetY = newY;
}

scene.addEventListener('mousemove', updateFromMouse);
if(window.DeviceOrientationEvent) {
  window.addEventListener('deviceorientation', updateFromOrientation);
}

applyTransforms();
